import { render, staticRenderFns } from "./QuickStartCard.vue?vue&type=template&id=39b9ff1f&scoped=true"
import script from "./QuickStartCard.vue?vue&type=script&lang=js"
export * from "./QuickStartCard.vue?vue&type=script&lang=js"
import style0 from "./QuickStartCard.vue?vue&type=style&index=0&id=39b9ff1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9ff1f",
  null
  
)

export default component.exports